import { Line } from '@models/line.model';
import { PartNumber } from '@models/partNumber.model';
import { User } from "@models/user.model";

export class ToolReturnHistory {
    public id: number;
    public name: string;
    public partNumber: PartNumber;
    public line: Line;
    public status: string;
    public reason: string;
    public createdBy: User;
    public createdDate: string;
    public modifiedBy: User;
    public modifiedDate: string;
    public type: string;
    public toolRequestId: number;

    constructor(toolReturnHistory: any = {}) {
        this.id = toolReturnHistory.id || 0;
        this.name = toolReturnHistory.name || '';

        if (toolReturnHistory.partNumber) {
            this.partNumber = this.mapPartNumber(toolReturnHistory.partNumber);
        }
        this.line = this.mapLine(toolReturnHistory.line);
        if (toolReturnHistory.createdBy) {
            this.createdBy = new User(toolReturnHistory.createdBy);
        }
        this.createdDate = toolReturnHistory.createdDate || '';
        if (toolReturnHistory.modifiedBy) {
            this.modifiedBy = new User(toolReturnHistory.modifiedBy);
        }
        this.modifiedDate = toolReturnHistory.modifiedDate || '';
        this.status = toolReturnHistory.status || '';
        this.reason = toolReturnHistory.reason || 'N/A';
        this.type = toolReturnHistory.type  || '';
        this.toolRequestId = toolReturnHistory.toolRequestId;
    }
    mapPartNumber(partNumber) {
        return new PartNumber(partNumber);
    }
    mapLine(line) {
        return new Line(line);
    }
}
